import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import SecurityCode from "./SecurityCode";
import ContactType from "./ContactType/Index";

import { Security } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

import { theme } from "../../../styles/theme";

import { useAuth } from "../../../hooks/useAuth";

const TwoFactor = () => {
  const { twoFactorAuthData } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    if (twoFactorAuthData.hasExpirationCodeVerified) {
      navigate("/auth/context");
    }
  }, [twoFactorAuthData, navigate]);

  return (
    <Box
      sx={{
        width: 490,
        minWidth: 420,
        backgroundColor: `${theme.palette.common.white}`,
        margin: "10%",
        padding: "16px 38px",
        borderRadius: "8px",
      }}
    >
      <Box
        textAlign="center"
        borderBottom="solid"
        paddingBottom={1}
        marginBottom={1}
        sx={{
          borderWidth: "thin",
        }}
      >
        <Security
          sx={{
            fontSize: "3.5rem",
            color: `${theme.palette.secondary.light}`,
          }}
        />
      </Box>
      <Typography
        variant="h5"
        color={theme.palette.primary.main}
        textAlign="center"
        marginTop={3}
        sx={{
          fontWeight: "500",
        }}
      >
        {twoFactorAuthData.hasSentContactType ? "Insira" : "Receba"} o código de
        verificação
      </Typography>

      {twoFactorAuthData.hasSentContactType ? (
        <SecurityCode />
      ) : (
        <ContactType />
      )}
    </Box>
  );
};

export default TwoFactor;
